export default [
  'Até 50',
  'De 51 a 100',
  'De 101 a 250',
  'De 251 a 500',
  '501+'
]
